import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=ff7788b0&scoped=true&"
import script from "./PageSet.vue?vue&type=script&lang=js&"
export * from "./PageSet.vue?vue&type=script&lang=js&"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=ff7788b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7788b0",
  null
  
)

export default component.exports